module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyOSAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgPGNpcmNsZSBjeD0iMTMiIGN5PSIxMyIgcj0iMTIuNSIgc3Ryb2tlPSIjNDdGODYzIi8+DQogIDxwYXRoIGQ9Ik0xMS41IDIyTDUgMTFMMTEuNSAxNS41TDI4LjUgM0wxMS41IDIyWiIgZmlsbD0iIzQ3Rjg2MyIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/ok.svg
// module id = 6rzM
// module chunks = 1